import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=57b80941&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=57b80941&prod&lang=sass&scoped=true"
import style1 from "./Product.vue?vue&type=style&index=1&id=57b80941&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b80941",
  null
  
)

export default component.exports